import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { SparkleIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { TaskProgressIndicator } from '../../../TaskProgressIndicator';

type SectionHeaderProps = Readonly<{
	completed: number;
	total: number;
}>;

export const SectionHeader: React.FC<SectionHeaderProps> = ({ completed, total }) => {
	return (
		<div className="flex w-full items-center justify-between" data-qa="dynamic-tasks-section-header">
			<div className="flex flex-col gap-0.5">
				<div className="flex items-center gap-2">
					<SparkleIcon size={16} className="text-typography-weak" />
					<Text variant="body" size="small" className="text-typography-weak" as="p">
						<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.section_header.label" />
					</Text>
				</div>
				<Text className="text-size-heading-small" id="dynamic-tasks-title" data-qa="dynamic-tasks-title" as="h3">
					<Translate value="corgi.petition.starter_dashboard_v2.dynamic_tasks.section_header.title" />
				</Text>
			</div>
			<TaskProgressIndicator completed={completed} total={total} />
		</div>
	);
};
